export class LoginRequest{

    public email! : string;
    public password! : string;
    public refreshToken? : string;

}